
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletters/preview",
      function () {
        return require("private-next-pages/newsletters/preview/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletters/preview"])
      });
    }
  